import React from 'react';

import {Action, ActionProps} from '../Action/index.ts';

export function IsolateItem(props: ActionProps) {
  return (
    <Action
      {...props}
      active={{
        fill: 'rgba(255, 70, 70, 0.95)',
        background: 'rgba(255, 70, 70, 0.1)',
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="-2 2 13 11">
        <path d="m2.828 15.555 7.777-7.779L2.828 0 0 2.828l4.949 4.948L0 12.727l2.828 2.828z"/>
      </svg>
    </Action>
    
  );
}

export default IsolateItem;